RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _) {

    'use strict';

    function itemRenderer(item) {
        const template = Marionette.TemplateCache.get('#favoritesTypeOptionTemplate');

        return $.tagHtml('div', {
            class: 'chart-type-option',
            html: template(item)
        });
    }

    const chartTypes = App.data.chartTypes;

    selectors.Widget = RivalIQ.views.Select.extend({
        itemRenderer: itemRenderer,

        onChange: function (widgetId) {
            const me = this;

            me.dashboardModel.changeWidgetId(widgetId);
        },

        resetItems: function () {
            const me = this;
            me.setItems(me.getChartOptions(), me.dashboardModel.getWidget().widgetId);
        },

        getChartOptions: function () {
            const me = this;
            const props = me.dashboardModel.getProps();

            const hasMultiPrivateChannelAdvanced = RivalIQ.state.plan.get('has_multi_handle_private_advanced');

            const charts = [];
            _.forEach(chartTypes, function (value, key) {
                if (value.beta && (
                    !me.dashboardModel.isCustomDashboard ||
                    !RivalIQ.state.account.inBeta(value.beta))) {

                    return;
                }

                if (me.dashboardModel.getProp('widgetGroupId') !== value.widgetGroupId) {
                    return;
                }

                if (value.disableChartTypeSelector && me.selected !== value.widgetId) {
                    return;
                }

                if (value.requiresMultiHandlePrivateAdvanced && !hasMultiPrivateChannelAdvanced) {
                    return;
                }

                charts.push(_.defaults({
                    id: key,
                    disabled: !Marionette.Dashboard.widgets.get(key).prototype.isSupported(props)
                }, value));
            });

            return charts;
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);

            me.selected = me.dashboardModel.getWidget().widgetId;
            me.items = me.getChartOptions();
        }
    });
});
